<template>
	<div :id="modalName">
		<b-modal :id="modalName" title="Edit Vendor" scrollable hide-footer size="lg">
            <template v-slot:modal-title>
                <span>Edit Vendor:</span>
            </template>

            <b-form v-if="ready" @submit.stop.prevent="editVendor">

                <b-row>
                    <b-col>
                        <b-form-group
                            id="input-group-name"
                            label="Name:"
                            label-for="input-name"
                            label-size="sm"
                        >
                            <b-form-input
                                id="input-name"
                                v-model="edit.name"
                                type="text"
                                placeholder=""
                                size="sm"
                                autocomplete="off"
                            >
                            </b-form-input>
                        </b-form-group>

                        <b-form-group
                            id="input-group-company"
                            label="Company:"
                            label-for="input-company"
                            label-size="sm"
                        >
                            <b-form-input
                                id="input-company"
                                v-model="edit.company"
                                type="text"
                                placeholder=""
                                size="sm"
                                autocomplete="off"
                            >
                            </b-form-input>
                        </b-form-group>
                        <b-form-group
                            id="input-group-contact"
                            label="Contact:"
                            label-for="input-contact"
                            label-size="sm"
                        >
                            <b-form-input
                                id="input-contact"
                                v-model="edit.contact"
                                type="text"
                                placeholder=""
                                size="sm"
                                autocomplete="off"
                            >
                            </b-form-input>
                        </b-form-group>
                    </b-col>

                    <b-col>
                        <b-form-group
                            id="input-group-email"
                            label="Email:"
                            label-for="input-email"
                            label-size="sm"
                        >
                            <b-form-input
                                id="input-email"
                                v-model="edit.email"
                                type="text"
                                placeholder=""
                                size="sm"
                                autocomplete="off"
                            >
                            </b-form-input>
                        </b-form-group>

                        <b-form-row>
                            <b-col>
                                <b-form-group
                                    id="input-group-phone"
                                    label="Phone:"
                                    label-for="input-phone"
                                    label-size="sm"
                                >
                                    <b-form-input
                                        id="input-phone"
                                        v-model="edit.phone"
                                        type="text"
                                        placeholder=""
                                        size="sm"
                                        autocomplete="off"
                                    >
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col>
                                <b-form-group
                                    id="input-group-mobile"
                                    label="Mobile:"
                                    label-for="input-mobile"
                                    label-size="sm"
                                >
                                    <b-form-input
                                        id="input-mobile"
                                        v-model="edit.mobile"
                                        type="text"
                                        placeholder=""
                                        size="sm"
                                        autocomplete="off"
                                    >
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col>
                                <b-form-group
                                    id="input-group-fax"
                                    label="Fax:"
                                    label-for="input-fax"
                                    label-size="sm"
                                >
                                    <b-form-input
                                        id="input-fax"
                                        v-model="edit.fax"
                                        type="text"
                                        placeholder=""
                                        size="sm"
                                        autocomplete="off"
                                    >
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-form-row>
                        <b-form-row>
                            <b-col cols="4">
                                <b-form-group
                                    id="input-group-other"
                                    label="Other:"
                                    label-for="input-other"
                                    label-size="sm"
                                >
                                    <b-form-input
                                        id="input-other"
                                        v-model="edit.other"
                                        type="text"
                                        placeholder=""
                                        size="sm"
                                        autocomplete="off"
                                    >
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col cols="8">
                                <b-form-group
                                    id="input-group-website"
                                    label="Website:"
                                    label-for="input-website"
                                    label-size="sm"
                                >
                                    <b-form-input
                                        id="input-website"
                                        v-model="edit.website"
                                        type="text"
                                        placeholder=""
                                        size="sm"
                                        autocomplete="off"
                                    >
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-form-row>
                    </b-col>
                </b-row>

                <b-card no-body>
                    <b-tabs card>
                        <b-tab title="Address" active>
                            <b-card-text>
                                <b-form-row>
                                    <b-col>
                                        <p>Billing Address:</p>
                                        <b-form-group
                                            id="textarea-group-billing-address-1"
                                        >
                                            <b-form-input
                                                id="input-billing-address-1"
                                                v-model="edit.billingAddress1"
                                                type="text"
                                                placeholder="Address 1"
                                                size="sm"
                                                autocomplete="off"
                                            >
                                            </b-form-input>
                                        </b-form-group>
                                        <b-form-group
                                            id="textarea-group-billing-address-2"
                                        >
                                            <b-form-input
                                                id="input-billing-address-2"
                                                v-model="edit.billingAddress2"
                                                type="text"
                                                placeholder="Address 2"
                                                size="sm"
                                                autocomplete="off"
                                            >
                                            </b-form-input>
                                        </b-form-group>
                                        <b-form-row>
                                            <b-col>
                                                <b-form-group
                                                    id="input-group-billing-city"
                                                >
                                                    <b-form-input
                                                        id="input-billing-city"
                                                        v-model="edit.billingCity"
                                                        type="text"
                                                        placeholder="City"
                                                        size="sm"
                                                        autocomplete="off"
                                                    >
                                                    </b-form-input>
                                                </b-form-group>
                                            </b-col>
                                            <b-col>
                                                <b-form-group
                                                    id="input-group-billing-state"
                                                >
                                                    <b-form-input
                                                        id="input-billing-state"
                                                        v-model="edit.billingState"
                                                        type="text"
                                                        placeholder="State"
                                                        size="sm"
                                                        autocomplete="off"
                                                    >
                                                    </b-form-input>
                                                </b-form-group>
                                            </b-col>
                                        </b-form-row>
                                        <b-form-row>
                                            <b-col>
                                                <b-form-group
                                                    id="input-group-billing-zip"
                                                >
                                                    <b-form-input
                                                        id="input-billing-zip"
                                                        v-model="edit.billingZip"
                                                        type="text"
                                                        placeholder="Zip"
                                                        size="sm"
                                                        autocomplete="off"
                                                    >
                                                    </b-form-input>
                                                </b-form-group>
                                            </b-col>
                                            <b-col>
                                                <b-form-group
                                                    id="input-group-billing-country"
                                                >
                                                    <b-form-input
                                                        id="input-billing-country"
                                                        v-model="edit.billingCountry"
                                                        type="text"
                                                        placeholder="Country"
                                                        size="sm"
                                                        autocomplete="off"
                                                    >
                                                    </b-form-input>
                                                </b-form-group>
                                            </b-col>
                                        </b-form-row>
                                    </b-col>
                                    <b-col>
                                        <p>Shipping Address:</p>
                                        <b-form-group
                                            id="textarea-group-shipping-address-1"
                                        >
                                            <b-form-input
                                                id="input-shipping-address-1"
                                                v-model="edit.shippingAddress1"
                                                type="text"
                                                placeholder="Address 1"
                                                size="sm"
                                                autocomplete="off"
                                            >
                                            </b-form-input>
                                        </b-form-group>
                                        <b-form-group
                                            id="textarea-group-shipping-address-2"
                                        >
                                            <b-form-input
                                                id="input-shipping-address-2"
                                                v-model="edit.shippingAddress2"
                                                type="text"
                                                placeholder="Address 2"
                                                size="sm"
                                                autocomplete="off"
                                            >
                                            </b-form-input>
                                        </b-form-group>
                                        <b-form-row>
                                            <b-col>
                                                <b-form-group
                                                    id="input-group-shipping-city"
                                                >
                                                    <b-form-input
                                                        id="input-shipping-city"
                                                        v-model="edit.shippingCity"
                                                        type="text"
                                                        placeholder="City"
                                                        size="sm"
                                                        autocomplete="off"
                                                    >
                                                    </b-form-input>
                                                </b-form-group>
                                            </b-col>
                                            <b-col>
                                                <b-form-group
                                                    id="input-group-shipping-state"
                                                >
                                                    <b-form-input
                                                        id="input-shipping-state"
                                                        v-model="edit.shippingState"
                                                        type="text"
                                                        placeholder="State"
                                                        size="sm"
                                                        autocomplete="off"
                                                    >
                                                    </b-form-input>
                                                </b-form-group>
                                            </b-col>
                                        </b-form-row>
                                        <b-form-row>
                                            <b-col>
                                                <b-form-group
                                                    id="input-group-shipping-zip"
                                                >
                                                    <b-form-input
                                                        id="input-shipping-zip"
                                                        v-model="edit.shippingZip"
                                                        type="text"
                                                        placeholder="Zip"
                                                        size="sm"
                                                        autocomplete="off"
                                                    >
                                                    </b-form-input>
                                                </b-form-group>
                                            </b-col>
                                            <b-col>
                                                <b-form-group
                                                    id="input-group-shipping-country"
                                                >
                                                    <b-form-input
                                                        id="input-shipping-country"
                                                        v-model="edit.shippingCountry"
                                                        type="text"
                                                        placeholder="Country"
                                                        size="sm"
                                                        autocomplete="off"
                                                    >
                                                    </b-form-input>
                                                </b-form-group>
                                            </b-col>
                                        </b-form-row>
                                    </b-col>
                                </b-form-row>
                            </b-card-text>
                        </b-tab>
                        <b-tab title="Notes">
                            <b-card-text>
                                <b-form-group
                                    id="textarea-group-notes"
                                    label="Notes:"
                                    label-for="textarea-notes"
                                    label-size="sm"
                                >
                                    <b-form-textarea
                                        id="textarea-notes"
                                        v-model="edit.notes"
                                        placeholder=""
                                        rows="7"
                                        size="sm"
                                        no-resize
                                    ></b-form-textarea>
                                </b-form-group>
                            </b-card-text>
                        </b-tab>
                        <b-tab title="Tax Info">
                            <b-card-text>
                                <b-form-group
                                    id="input-group-ein"
                                    label="EIN #:"
                                    label-for="input-ein"
                                    label-size="sm"
                                >
                                    <b-form-input
                                        id="input-ein"
                                        v-model="edit.ein"
                                        type="text"
                                        placeholder=""
                                        size="sm"
                                        autocomplete="off"
                                    >
                                    </b-form-input>
                                </b-form-group>
                            </b-card-text>
                        </b-tab>
                        <b-tab title="Preferred Payment & Delivery">
                            <b-card-text>
                                <b-form-row>
                                    <b-col>
                                        <b-form-group
                                            id="select-group-terms"
                                            label="Terms:"
                                            label-for="select-terms"
                                            label-size="sm"
                                        >
                                            <b-form-select
                                                v-model="edit.terms"
                                                id="select-term"
                                                size="sm"
                                                :options="lists.terms"
                                            ></b-form-select>
                                        </b-form-group>
                                        <b-form-group
                                            id="textarea-group-banking-info"
                                            label="Banking Info:"
                                            label-for="textarea-banking-info"
                                            label-size="sm"
                                        >
                                            <b-form-textarea
                                                id="textarea-banking-info"
                                                v-model="edit.bankingInfo"
                                                placeholder=""
                                                rows="5"
                                                size="sm"
                                                no-resize
                                            ></b-form-textarea>
                                        </b-form-group>
                                    </b-col>
                                    <b-col>
                                        <b-form-row>
                                            <b-col>
                                                <b-form-group
                                                    id="input-group-opening-balance"
                                                    label="Opening Balance:"
                                                    label-for="input-opening-balance"
                                                    label-size="sm"
                                                >
                                                    <b-form-input
                                                        id="input-opening-balance"
                                                        v-model="edit.openingBalance"
                                                        type="text"
                                                        placeholder=""
                                                        size="sm"
                                                        autocomplete="off"
                                                    >
                                                    </b-form-input>
                                                </b-form-group>
                                            </b-col>
                                            <b-col>
                                                <b-form-group
                                                    id="datepicker-group-opening-balance-date"
                                                    label="as of:"
                                                    label-for="datepicker-opening-balance-date"
                                                    label-size="sm"
                                                >
                                                    <b-form-datepicker
                                                        id="datepicker-opening-balance-date"
                                                        v-model="edit.openingBalanceDate"
                                                        class="mb-2"
                                                        size="sm"
                                                        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                                        locale="en"
                                                    >
                                                    </b-form-datepicker>
                                                </b-form-group>
                                            </b-col>
                                        </b-form-row>
                                    </b-col>
                                </b-form-row>
                            </b-card-text>
                        </b-tab>
                        <b-tab title="Additional Info">
                            <b-card-text></b-card-text>
                        </b-tab>
                    </b-tabs>
                </b-card>
                <b-form-row v-if="$can('edit-vendor-detail') || $can('view-all')" class="button-row">
                    <b-col cols=2>
                        <b-button type="submit" variant="primary" class="btn-sm">
                            <span v-if="submitting">
                                <b-spinner small type="grow"></b-spinner>
                                Updating...
                            </span>
                            <span v-else>Update</span>
                        </b-button>
                    </b-col>
                </b-form-row>
            </b-form>
        </b-modal>
	</div>
</template>

<script>
	export default {
		props: [
            'row'
		],

		components: {

		},

		data() {
			return {
				modalName: 'modal-lists-vendors-edit-vendor',
                edit: {},
                newUser: {},
                newPassword: '',
                ready: 0,
                lists: {
                    terms: [
                        'Due On Receipt',
                        'Net 30',
                        'COD MO',
                        'COD CC',
                        'Credit Card',
                        'Straight Ship'
                    ]
                },
                submitting: 0,
                submittingPassword: 0,
                submittingNewUser: 0,
                submittingUnlink: 0,
			}
		},

		methods: {
            editVendor() {
                this.submitting = 1
                let editData = this.edit

                let url = 'api/lists/vendors/updatevendor'
                axios.post(url, {
                    editData
                })
                .then((res) => {
                    this.submitting = 0

                    if (res.data.status == 'success') {
                        this.closeModal(this.modalName)
                        this.showAlertBox('success', 'Vendor Updated', 'vendor ' + editData.name + ' updated successfully!')
                        this.$emit('getRow')
                    } else {
                        this.showAlertBox('error', 'Error', 'Error updating vendor!')
                    }
                }, () => {
                    this.has_error = true
                })
            },

            populateRow() {
                this.edit.id = this.row.id
                this.edit.name = this.row.name
                this.edit.email = this.row.email
                this.edit.buyerName = this.row.buyers_name
                this.edit.phone = this.row.phone
                this.edit.fax = this.row.fax
                this.edit.mobile = this.row.mobile
                this.edit.website = this.row.website
                this.edit.terms = this.row.terms
                this.edit.contact = this.row.contact
                this.edit.bankingInfo = this.row.banking_info
                this.edit.ein = this.row.ein
                this.edit.billingAddress1 = this.row.billing_address_1
                this.edit.billingAddress2 = this.row.billing_address_2
                this.edit.billingCity = this.row.billing_city
                this.edit.billingState = this.row.billing_state
                this.edit.billingZip = this.row.billing_postal_code
                this.edit.billingCountry = this.row.billing_country
                this.edit.shippingAddress1 = this.row.shipping_address_1
                this.edit.shippingAddress2 = this.row.shipping_address_2
                this.edit.shippingCity = this.row.shipping_city
                this.edit.shippingState = this.row.shipping_state
                this.edit.shippingZip = this.row.shipping_postal_code
                this.edit.shippingCountry = this.row.shipping_country
                this.edit.notes = this.row.notes
                this.edit.company = this.row.company

                this.ready = 1
            }
		},

		computed: {

		},

		mounted() {
            this.populateRow()
		}
	}
</script>
<style lang="scss">
    #modal-lists-vendors-edit-vendor {
        .modal-content {
            .button-row {
                margin-top: 15px;
            }
        }
    }
</style>
